<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { usePopup } from '@/stores/popup'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
  DialogClose,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog'
import { X } from 'lucide-vue-next'
const popup = usePopup()

function closePopup() {
  if (popup.bigsizealertPopup) {
    popup.bigsizealertPopup = false
  }
}
</script>
<template>
  <Dialog v-model:open="popup.bigsizealertPopup">
    <DialogTrigger as-child>
      <button type="button" class="underline">
        {{ $t('Information') }}
      </button>
    </DialogTrigger>
    <DialogContent class="max-w-lg">
      <DialogClose
        class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
      >
        <X class="w-6 h-6" />
        <span class="sr-only">{{ $t('Close') }}</span>
      </DialogClose>
      <DialogHeader>
        <DialogTitle>
          <h3 class="font-semibold text-2xl lg:text-3xl">
            {{ $t('Assembly of pieces of material') }}
          </h3>
        </DialogTitle>

      </DialogHeader>
      <div class="fabrics-block-inner">
        <div class="fabrics-list-wrapper flex flex-col gap-10">
          <div class="dialog-image-wrapper flex justify-center">
            <figure>
              <img src="/images/shapes/square-material.png" :alt="$t('Assembly sewing')" />
              <figcaption>{{ $t('Assembly sewing') }}</figcaption>
            </figure>
          </div>
          <div>
            <DialogDescription class="text-black text-base lg:text-lg">
            <p>
              {{
                $t(
                  "To make a cushion of the measurements you've entered, we need to assemble two or more pieces of material.",
                )
              }}
            </p>
            <p>
              {{
                $t(
                  'The assembly sewing will be made in the center, or in the case of more than two pieces of material, it will partition the cushion into sections of equal size.',
                )
              }}
            </p>
            <p>
              {{
                $t(
                  'We will choose a type of sewing that is as discrete as we can possibly make it.',
                )
              }}
            </p>
          </DialogDescription>
          </div>

          <div class="button-wrapper">
            <button type="button" class="" @click="closePopup">
              x
              {{ $t('Close') }}
            </button>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 50;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: hsla(0 0 0 / 0.8);
}
.modal-container {
  display: flex;
  position: fixed;
  left: 50px;
  top: 33%;
  right: 50px;
  margin: auto;
  padding: 40px;
  background-color: #fff;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.cross {
  float: right;
  cursor: pointer;
  font-size: 30px;
  right: 40px;
  position: absolute;
}
.fabrics-block-inner {
  display: flex;
  justify-content: start;
  flex-direction: column;
  width: 100%;
}
</style>
